import React from "react";

const UploadWidget = () => {
  const handleUpload = async (event: any) => {
    const file = event.target.files[0];
    if (!file) return;
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "ocssc_images");
    data.append("cloud_name", "dbfyzgffj");

    try {
      const apiRes = await fetch(
        "https://api.cloudinary.com/v1_1/dbfyzgffj/image/upload",
        {
          method: "POST",
          body: data,
        }
      );
      const res = await apiRes.json();
      console.log("res", res);
      alert("Upload success");
    } catch (error) {
      alert("Upload failed");
    }
  };

  return (
    <div className="flex justify-center items-center h-[100vh]">
      <div className="w-100 h-100 border border-gray-300 rounded-lg flex justify-center items-center shadow">
        <input
          type="file"
          className="border border-gray-300"
          title="Upload image"
          onChange={handleUpload}
        />
      </div>
    </div>
  );
};

export default UploadWidget;
